var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60416 10.9953L4.57083 13.162L3.44416 16.6512C3.26209 17.1923 3.25978 17.7778 3.43759 18.3204C3.61539 18.863 3.96379 19.3336 4.43083 19.662C4.88987 20.001 5.44616 20.1826 6.01679 20.1797C6.58743 20.1769 7.14187 19.9897 7.5975 19.6462L10.4983 17.5112L13.4 19.6437C13.8582 19.9807 14.4115 20.1638 14.9803 20.1665C15.5491 20.1693 16.1042 19.9916 16.5656 19.6591C17.0271 19.3265 17.3712 18.8562 17.5486 18.3157C17.7259 17.7752 17.7273 17.1925 17.5525 16.6512L16.4258 13.162L19.3925 10.9953C19.8501 10.6607 20.1903 10.1901 20.3645 9.65065C20.5386 9.11118 20.5378 8.53048 20.3622 7.99148C20.1866 7.45248 19.8452 6.98276 19.3867 6.64941C18.9282 6.31606 18.376 6.13613 17.8092 6.13532H14.165L13.0592 2.68866C12.8853 2.14612 12.5436 1.67283 12.0833 1.33704C11.6231 1.00125 11.0681 0.820313 10.4983 0.820312C9.92861 0.820312 9.37361 1.00125 8.91336 1.33704C8.45311 1.67283 8.1114 2.14612 7.9375 2.68866L6.83166 6.13532H3.19083C2.62395 6.13613 2.07182 6.31606 1.61331 6.64941C1.1548 6.98276 0.813364 7.45248 0.637764 7.99148C0.462165 8.53048 0.461388 9.11118 0.635544 9.65065C0.8097 10.1901 1.14988 10.6607 1.6075 10.9953H1.60416Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fdaf8a787f14b4ee697ef5d8973abe50.svg";
export { ForwardRef as ReactComponent };